module.exports = __webpack_public_path__ + "static/media/upgrade.94cdc6fb.svg";